import React, { type FC } from 'react';
import { Provider } from 'react-redux';
import { withErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import { type Store } from 'redux';
import { ApolloProvider } from '@apollo/client';
import { MUIProvider } from '@is24at/react-hooks';
import { withSsoStatus } from '@is24at/react-redux';
import ssoStatusApiClient from 'api/ssoStatusApiClient';
import { getApolloClient } from 'api/apolloClient';
import { ReduxAsyncConnect } from 'core/reduxAsync';
import AppError from '../AppError';
import 'styles/index.scss';

interface AppProps {
  routes: unknown[];
  store: Store<any>;
}

const App: FC<any> = ({ store, routes }: AppProps) => (
  <MUIProvider>
    <ApolloProvider client={getApolloClient()}>
      <Provider store={store} key="provider">
        <BrowserRouter>
          <ReduxAsyncConnect routes={routes} />
        </BrowserRouter>
      </Provider>
    </ApolloProvider>
  </MUIProvider>
);

export default withErrorBoundary(withSsoStatus(App, ssoStatusApiClient), {
  FallbackComponent: AppError,
});
